/**
 * goober (used by react-hot-toast) does `(querySelector("#_goober") || newStyle).firstChild.data`.
 * If #_goober exists but is empty, firstChild is null → "Cannot read properties of undefined (reading 'data')".
 * Run once on the client so staging/prefetch cannot hit that state even if HTML or another script left an empty tag.
 */
export function ensureGooberStyleTextNode() {
  if (typeof document === "undefined") return;
  let el = document.getElementById("_goober");
  if (!el) {
    el = document.createElement("style");
    el.id = "_goober";
    (document.head || document.documentElement).appendChild(el);
  }
  if (!el.firstChild) {
    el.appendChild(document.createTextNode(" "));
  }
}
